import { render, staticRenderFns } from "./BusinessHours.vue?vue&type=template&id=515bf560&scoped=true"
import script from "./BusinessHours.vue?vue&type=script&lang=js"
export * from "./BusinessHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bf560",
  null
  
)

export default component.exports